<div class="t-popup-body" style="overflow: auto;width:50em;" [formGroup]="gfs.Form"  >
    <button class="t-btn-popup-close" aria-label="close popup" (click)="close(true)"></button>
    <div class="formHeader">
        <h2 style="align-self: center;">
            Release Form
        </h2>
        <span  class="icon-print" (click)="printForm()" style="margin-inline-end: 1.5em;" aria-label="Print" matTooltip="Print"><img src="../../assets/icons/print.svg"></span>
    </div>
    <div class="m-box" style="direction: rtl; margin: 1em 0; justify-content: space-between;">
        <section class="w100" style="direction: rtl; justify-content: space-evenly; display: flex;">
            <span>זיהוי מטופל <input type="checkbox" formControlName="PatientIdentification"></span>
            <span> בדיקות לביצוע:</span>
            <span>קולונוסקופיה <input type="checkbox" formControlName="Colonoscopy"></span>
            <span>גסטרוסקופיה <input type="checkbox" formControlName="Gastroscopy"></span>
            <span>סיגמואידוסקופיה <input type="checkbox" formControlName="Sigmoidoscopy"></span>
        </section>
        <div style="display: flex; margin: 0 3.5em;">
            <div class="w40" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 0.3em; align-self: center;">
                    שעת סיום הבדיקה
                </span>
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input  class="t-field-text" type="time" id="CheckTime" formControlName="EndTime" />
                </span>
            </div>
            <div class="w40" style="display: flex;margin-top: 0; margin: 0.3em;">
                <span style="margin-left: 0.3em; align-self: center;">
                    רופא
                </span>
                <span class="t-field t-field--number" style="direction: rtl;">
                    <input class="t-field-text" type="text" formControlName="AssignedDoctor" />
                </span>
            </div>
        </div>
    </div>
    <div style="display: revert;">
        <label class="t-label-top" style="direction: rtl;">
            <span style="width: 8em;">  מצב הכרה:  </span>
            <div class="l-flex-c l-flex-w indicative-fieldset" style="flex-wrap: inherit;direction: rtl;" (dblclick)="gfs.Form.get('consciousState').setValue('')">

                <label class="t-label-top">
                    <input type="radio" formControlName="consciousState" value="awake" class="custom-check -sq" />
                    <i class="customInput-display -sq"></i>
                    <span>
                        ער/ה  
                    </span>
                </label>
                <label class="t-label-top">
                    <input type="radio" formControlName="consciousState" value="sleepy" class="custom-check -sq" />
                    <i class="customInput-display -sq"></i>
                    <span>
                     מנומנם/ת
                    </span>
                </label>

                <label class="t-label-top">
                    <input type="radio" formControlName="consciousState" value="dormant" class="custom-check -sq" />
                    <i class="customInput-display -sq"></i>
                    <span>
                        רדום 
                    </span>
                </label>
            </div>
        </label>
    </div>
    <div style="width: 100%;direction: rtl;margin-top: 2em;">
        <label class="t-label-top">
            <span style="width: 18em;">  מתן שתייה:</span>
            <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('providingDrink').setValue(-1)">

                <label class="observe">

                    <input type="radio" class="custom-check customInput" formControlName="providingDrink" [value]="1"><i
                        class="customInput-display"></i>

                    <span>
                        כן
                    </span>
                </label>

                <label class="not-observed">

                    <input type="radio" class="custom-check customInput" formControlName="providingDrink" [value]="0"><i
                        class="customInput-display"></i>

                    <span>
                        לא
                    </span>

                </label>
            </div>
        </label>

    </div>
    <div style="width: 100%;direction: rtl;">
        <label class="t-label-top">
            <span style="width: 18em;">  הדרכה:</span>
            <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('InstructionRelease').setValue(-1)">

                <label class="observe">

                    <input type="radio" class="custom-check customInput" formControlName="InstructionRelease" [value]="1"><i
                        class="customInput-display"></i>

                    <span>
                        כן
                    </span>
                </label>

                <label class="not-observed">

                    <input type="radio" class="custom-check customInput" formControlName="InstructionRelease" [value]="0"><i
                        class="customInput-display"></i>

                    <span>
                        לא
                    </span>

                </label>
            </div>
        </label>

    </div>
    <div style="width: 100%;direction: rtl;">
        <label class="t-label-top">
            <span style="width: 18em;">  שיניים תותבות:</span>
            <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('Dentures').setValue(-1)">

                <label class="observe">

                    <input type="radio" class="custom-check customInput" formControlName="Dentures" [value]="1"><i
                        class="customInput-display"></i>

                    <span>
                        כן
                    </span>
                </label>

                <label class="not-observed">

                    <input type="radio" class="custom-check customInput" formControlName="Dentures" [value]="0"><i
                        class="customInput-display"></i>

                    <span>
                        לא
                    </span>

                </label>
                <label class="not-observed">

                    <input type="radio" class="custom-check customInput" formControlName="Dentures" [value]="2"><i
                        class="customInput-display"></i>

                    <span>
                        לא רלוונטי
                    </span>

                </label>
            </div>
        </label>

    </div>
    <div style="width: 100%;direction: rtl;">
        <label class="t-label-top">
            <span style="width: 18em;">   ציוד אישי:</span>
            <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('personalEquipment').setValue(-1)">

                <label class="observe">

                    <input type="radio" class="custom-check customInput" formControlName="personalEquipment" [value]="1"><i
                        class="customInput-display"></i>

                    <span>
                        כן
                    </span>
                </label>

                <label class="not-observed">

                    <input type="radio" class="custom-check customInput" formControlName="personalEquipment" [value]="0"><i
                        class="customInput-display"></i>

                    <span>
                        לא
                    </span>

                </label>
            </div>
        </label>

    </div>
    <div style="width: 100%;direction: rtl;">
        <label class="t-label-top">
            <span style="width: 18em;">הוצאת ונפלון:</span>
            <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('TakeOutVanaflon').setValue(-1)">

                <label class="observe">

                    <input type="radio" class="custom-check customInput" formControlName="TakeOutVanaflon" [value]="1"><i
                        class="customInput-display"></i>

                    <span>
                        כן
                    </span>
                </label>

                <label class="not-observed">

                    <input type="radio" class="custom-check customInput" formControlName="TakeOutVanaflon" [value]="0"><i
                        class="customInput-display"></i>

                    <span>
                        לא
                    </span>

                </label>
            </div>
        </label>

    </div>
    <div style="width: 100%;direction: rtl;">
        <label class="t-label-top">
            <span style="width: 18em;"> האם יש מלווה:</span>
            <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('accompanied').setValue(-1)">

                <label class="observe">

                    <input type="radio" class="custom-check customInput" formControlName="accompanied" [value]="1"><i
                        class="customInput-display"></i>

                    <span>
                        כן
                    </span>
                </label>

                <label class="not-observed">

                    <input type="radio" class="custom-check customInput" formControlName="accompanied" [value]="0"><i
                        class="customInput-display"></i>

                    <span>
                        לא
                    </span>

                </label>
            </div>
        </label>

    </div>
    <div style="direction: rtl; padding-top: 3em;display: flex;flex-direction: row;justify-content: space-between;">
    <div class="w33">

        <div class="l-flex l-flex-c t-field t-field-pad">

            <label class="w50" >
               שעת שחרור:
            </label>

            <i class="t-sep"></i>

            <span class="t-validation-wrap l-fg1 w70">
                <input type="time" formControlName="ReleaseTime"  class="t-field-text w100"/>
            </span>
            
        </div>
        
    </div>
    <div >
        <mat-form-field>
            <mat-label [ngClass]="['mat-select-value']">ע"י אח/ות: </mat-label>
            <mat-select [formControl]="this.gfs.Form.get('ResponsibleForm')" multiple [ngClass]="['mat-select-value','mat-form-field']">
              <mat-option  [value]="ls.username" [ngClass]="['mat-select-value']">{{ls.username}}</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- <div style="display: flex; justify-content: center; align-items: center;">
            <input class="t-field t-field-text" placeholder="הוסף ממלא לטופס"  [(ngModel)]="responsible"  [ngModelOptions]="{standalone: true}"/>
            <button class="btnAdd" (click)="addResponsible()">הוסף</button>
        </div> -->
    </div>
    <div style="display: grid;place-self: center;">
        <span>חתימת האח/ות:</span>
        <canvas id="canvasDoc" #canvasSign [style.border]="'1px solid black'"  [ngClass]="'can-shadow'" width="200" height="100"   (click)="setCanvas()"></canvas>
        <button   style="position: relative;top: -2em;width: fit-content;" (click)="clearSign()">                                            
            <ng-container>
                <img src="../../assets/icons/login/reset.png" style='height: 1.5em;width: 1.5em' matTooltip="Clear">
            </ng-container>
        </button>

    </div>
    
</div>
<button class="accept" (click)="close(true)">Save and Close</button>

</div>
